if (!customElements.get('cart-count')) {
  customElements.define(
    'cart-count',
    class CartCount extends window.BAO.CustomElement() {
      setupListeners () {
        super.setupListeners()

        this.onCartChanged = this.onCartChanged.bind(this)

        window.BAO.eventBus.addEventListener(
          window.BAO.EVENTS.PUSH_CART.AFTER_ADD,
          this.onCartChanged,
        )
        window.BAO.eventBus.addEventListener(
          window.BAO.EVENTS.PUSH_CART.AFTER_MULTIPLE_ADD,
          this.onCartChanged,
        )
        window.BAO.eventBus.addEventListener(
          window.BAO.EVENTS.PUSH_CART.AFTER_UPDATE_ITEM_QUANTITY,
          this.onCartChanged,
        )
        window.BAO.eventBus.addEventListener(
          window.BAO.EVENTS.PUSH_CART.AFTER_UPDATE_REMOVE_ITEM,
          this.onCartChanged,
        )
      }

      onCartChanged (e) {
        const { state } = e.detail
        if (!state) return
        if (!('push-cart-count' in state?.sections)) return

        const count = Number(this.getCount(state.sections['push-cart-count']))

        this.textContent = count.toString()
        this.setAttribute('aria-hidden', (count === 0).toString())
      }

      getCount (html) {
        const DOM = window.BAO.utils.sectionRenderer.convertToDOM(html)

        return DOM.querySelector('#push-cart-count').textContent
      }
    },
  )
}
